<template>
	<div class="nav-layer">
		<transition name="slide" mode="out-in">
			<div v-show="showSlide" class="nav-slide">
				<div class="nav-slide-header">
					<!-- @slot Slot for header content. Defaults to company and -->
					<slot name="nav-header">
						<span class="nav-slide-header-text">{{company}}</span>
					</slot>
					<t-icon-button
						class="nav-slide-header-button"
						icon="menu-closed"
						type="bp"
						appearance="transparent"
						iconSize="medium"
						size="large"
						@click="onClose"
					/>
				</div>

				<div class="nav-slide-inner">
					<div class="nav-slide-content">
						<!-- @slot Default slot for nav content -->
						<slot />
					</div>

					<div class="nav-slide-footer">
						<slot name="nav-footer">
							<div v-if="!!$slots['nav-footer-prepend']" class="nav-footer-prepend" >
								<slot name="nav-footer-prepend" />
							</div>
							<!-- eslint-disable-next-line -->
							<div class="nav-slide-footer-logo" v-html="timpexLogo" />
							<div class="nav-slide-footer-text">TMS Sight</div>
						</slot>
					</div>
				</div>
			</div>
		</transition>

		<t-transition name="slide-fade" mode="out-in">
			<router-view class="router-view"/>
		</t-transition>
	</div>
</template>

<script>
import timpexLogo from '!!raw-loader!@/assets/timpexLogo.svg';
export default {
	props: {
		company: { type: String },
		showSlide: { type: Boolean }
	},
	computed: {
		timpexLogo() {
			return timpexLogo;
		}
	},
	methods: {
		onClose() {
			this.$emit('close');
			this.$emit('update:showSlide', false);
		}
	}
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';
@import '~@/components/evergreen/scss/text';

.nav-layer {
	height: 100%;
	display: grid;
	grid-auto-flow: column;
	grid-template-columns: auto 1fr;
}

.router-view {
	grid-column: 2/auto;
	overflow: hidden;
}

.nav-slide {
	position: static;
	display: flex;
	flex-direction: column;
	grid-column: 0/1;
	padding: 0px 8px;
	width: 200px;
	height: 100%;
	background-color: get-color($background, 'nav-slide');
	transform: translateX(0);
	z-index: 9;
	overflow-y: auto;
}

.nav-slide-header {
	display: flex;
	flex-shrink: 0;
	align-items: center;
	justify-content: space-between;
	margin: 12px 0px;
}

.nav-slide-header-text {
	@extend %text-large;
	font-size: 22px;
	font-weight: 500;
	color: get-color($text, 'default');
	margin-top: 0;
	margin-left: 16px;
	margin-right: 8px;
}

.nav-slide-header-button {
	margin-right: 8px;
}

.nav-slide-inner {
	overflow-y: auto;
	flex: 1;
	display: flex;
	flex-direction: column;
}

.nav-slide-content {
	flex: 1;
}

.nav-slide-footer {
	flex-direction: column;
	margin: 12px 16px;
}

.nav-slide-footer-logo {
	color: get-color($neutral-scale, 'N9');
	width: 100px;
}

.nav-slide-footer-text {
	@extend %text-small;
	font-weight: 600;
	margin-top: 0;
	color: get-color($text, 'muted');
}

.nav-footer-prepend {
	margin-bottom:10px;
}

.slide-enter-active, .slide-leave-active {
	transition: transform .2s ease-in-out;
}

.slide-enter, .slide-leave-to {
	transform: translateX(-100%);
}

.fade-enter-active, .fade-leave-active {
	transition: all .2s;
}

.fade-enter, .fade-leave-to {
	opacity: 0;
	transform: translateX(-10px);
}
</style>
